import React, {PureComponent} from 'react';
import BEMHelper from 'react-bem-helper';
import {Field, FieldArray, getFormValues, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import FieldCheckbox from '../Field/FieldCheckbox';
import * as ActionsConfig from '../../redux/modules/config';
import * as ActionsNews from '../../redux/modules/news';
import * as ActionsArticles from '../../redux/modules/articles';
import * as ActionsText from '../../redux/modules/text';
import Notice from '../ListEntity/Entities/Notice';
import Article from '../ListEntity/Entities/Article';

const FORM_NAME = 'PartnerForm';

const bem = new BEMHelper({
  name: 'select-entities-form',
  prefix: 'planet-'
});
const bemManualSelect = new BEMHelper({
  name: 'select-entities-manual',
  prefix: 'planet-'
});

const ManualSelect = ({entity, fields, list}) => {
  const getById = (id) => {
    for (let i = 0; i < list.length; i++) {
      if (list[i].id === id) {
        return list[i];
      }
    }
    return null;
  };

  const change = (event, index) => {
    if (fields.get(index)) {
      fields.insert(index, +event.target.value);
      fields.remove(index + 1);
    } else {
      fields.insert(index, +event.target.value);
    }
  };
  const Comp = entity === 'Article' ? Article : Notice;
  return (
    <div {...bemManualSelect()}>
      <div className="row">
        {
          [...Array(4)].map((v, i) => {
            const data = getById(fields.get(i));
            return (
              <div key={i} {...bemManualSelect('item', null, 'col-md-3')}>
                <div {...bemManualSelect('actions')}>
                  <select className="select" onChange={(ev) => {
                    change(ev, i);
                  }} value={''}>
                    <option>Select</option>
                    {
                      list.map((v, i) => {
                        return (<option key={i} value={v.id}>{v.title}</option>);
                      })
                    }
                  </select>
                  <div>
                    {
                      data && <button
                        type="button"
                        className="btn btn-primary btn-xs"
                        onClick={() => {
                          fields.remove(i);
                        }}>Remove
                      </button>
                    }
                  </div>
                </div>
                {
                  data && <Comp {...data}/>
                }
              </div>
            );
          })
        }
      </div>
    </div>
  );
};

class Component extends PureComponent {

  getData() {
    this.props.getAction(this.props.section);
    if (this.props.entity === 'Article') {
      this.props.getArticlesAction();
    } else {
      this.props.getNewsAction();
    }
  }

  componentWillMount() {
    this.getData();
  }

  handlerSubmit(values = {}) {
    const {putAction, section, config, close, getTextAction} = this.props;
    const newC = {...config};
    const newD = {...values};
    if (newD.auto === true) {
      newD.values = [];
    } else {
      newD.auto = false;
    }
    newC.config = JSON.stringify(newD);
    return putAction(section, newC).then(() => {
      getTextAction('home').then(() => {
        close();
      });
    });
  }

  render() {
    const {myValues, entity, news, articles, handleSubmit, pristine, reset, submitting} = this.props;
    const auto = myValues.auto === true ? true : false;

    return (
      <div {...bem()}>
        <form onSubmit={handleSubmit(this.handlerSubmit.bind(this))}>
          <div {...bem('form')}>
            <div>
              <Field
                label="Automatic"
                name="auto"
                type="checkbox"
                component={FieldCheckbox}/>
            </div>
            <div>
              {
                auto && <div>The information will be displayed automatically based on the dates</div>
              }
              {
                !auto && <FieldArray
                  entity={entity}
                  list={entity === 'Article' ? articles : news}
                  articles={articles}
                  name="values"
                  component={ManualSelect}/>
              }
            </div>
          </div>
          <div {...bem('buttons')}>
            <button
              type="submit"
              disabled={pristine || submitting}
              className="btn  btn-primary btn-xl">Save
            </button>
            <button
              type="button"
              disabled={pristine || submitting}
              className="btn btn-primary btn-xl"
              onClick={reset}>Clear
            </button>
          </div>
        </form>
      </div>
    );
  }
}

Component.propTypes = {};
Component.defaultProps = {};

Component = reduxForm({
  form: FORM_NAME
})(Component);

export default connect(
  (state) => {
    return {
      myValues: getFormValues(FORM_NAME)(state) || {},
      news: state.news.values,
      articles: state.articles.values,
      enableReinitialize: true,
      config: state.config.values,
      initialValues: state.config.values.config || {}
    };
  },
  (dispatch) => {
    return bindActionCreators(
      {
        getAction: ActionsConfig.get,
        putAction: ActionsConfig.put,
        getNewsAction: ActionsNews.get,
        getArticlesAction: ActionsArticles.get,
        getTextAction: ActionsText.get,
      }, dispatch);
  }
)(Component);



// WEBPACK FOOTER //
// ./src/components/select-entities/Form.js